






























export default {
    name: "BulletinDeSalaireModalPdfViewer",
    props: {
        files: {
            type: Array,
            required: true,
        },
        page: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedPdfIndex: 0,
        };
    },
    methods: {
        selectPdfFile(index: number): void {
            this.selectedPdfIndex = index;
        },
    },
};
